import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { BaseDtoSearchService, IBaseDto } from './base-dto.service';
import { CompanyClient, SearchCompaniesBasicDataParameters } from './reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class ReportingCompetingBidderSearchService extends BaseDtoSearchService {
    constructor(protected client: CompanyClient) {
        super();
    }

    async search(filterText: string): Promise<IBaseDto[]> {
        return await lastValueFrom(
            this.client.companySearchCompetingBiddersData({
                filterText,
                isActive: true
            } as SearchCompaniesBasicDataParameters)
        );
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    override getById(id: number): Promise<IBaseDto> {
        throw new Error('Method not implemented.');
    }

    async getByIds(companyIds: number[]): Promise<IBaseDto[]> {
        return await lastValueFrom(
            this.client.companySearchCompetingBiddersData({
                companyIds
            } as SearchCompaniesBasicDataParameters)
        );
    }
}
